<template>
    <form ref="form" v-on="formEvents">

        <transition name="slide-in-top">
            <div >
                <div v-if="loading"
                     class="text-center text-primary text-20 line-height-07 mb-5 mt-5 d-flex justify-content-center align-items-center">
                    <div class="loader"></div>
                </div>

                <div v-if="!loading " class="form-group">
                    <label>Category</label>
                    <select required v-model="form.category"
                            :class="[ 'custom-select' , form.errors.get('category') ? 'is-invalid' : '' ]">
                        <option value="">Choose Category</option>
                        <option v-for="cat in categories" :value="cat">{{ cat.replace('_', ' ') }}</option>
                    </select>
                    <div v-text="form.errors.get('category')" class="invalid-feedback"/>
                </div>


                <div v-if="!loading" class="form-group">
                    <label>Bundle</label>
                    <select required v-model="form.bundle" :disabled ="!form.category"
                            :class="[ 'custom-select' , form.errors.get('bundle') ? 'is-invalid' : '' ]">
                        <option value="">Choose Bundle</option>
                        <option v-for="b in filteredBundles" :value="b.id">
                            {{ form.currency }}{{b.price }} - {{ b.ProductName }} - {{ b.ProductDescription }}
                        </option>
                    </select>
                    <div v-text="form.errors.get('bundle')" class="invalid-feedback"/>
                </div>

                <div class="form-group">
                    <label>SMS Notification Number </label>
                    <phone-input v-model="form.phone"></phone-input>
                    <div v-text="form.errors.get('phone')" class="text-danger"/>
                    <small>* Used to deliver your Recharge PIN</small>
                </div>

                <div class="form-group">
                    <label>Pay with</label>
                    <select v-model="form.payment"
                            :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                        <option v-if="form.currency === 'ZWG'" value="ecocash">EcoCash ZWG</option>
                        <option value="ecocash-usd">EcoCash USD</option>
                        <option value="stripe">International Card</option>
                    </select>
                    <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                </div>

                <div v-if="form.currency === 'USD' && form.payment === 'stripe'" class="alert alert-warning">
                    We have added a {{ paymentPremium }}% fee to recover the costs of card processing.
                    This currently applies only to this product. You will therefore be billed ${{ totalPayment }} at checkout.
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="terms" required v-model="paymentPremiumAccepted">
                        <label class="custom-control-label font-weight-bold" for="terms">
                            I accept these terms.
                        </label>
                    </div>
                </div>

                <div v-if="form.payment === 'ecocash' || form.payment === 'ecocash-usd'" class="form-group">
                    <label>EcoCash Phone Number</label>
                    <phone-input v-model="form.ecocash" :countries="['ZW']"></phone-input>
                    <div v-text="form.errors.get('ecocash')" class="text-danger"/>
                </div>

                <div class="form-group">
                    <label>Email</label>
                    <input type="email" v-model="form.email" value="email"
                           required
                           :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                           placeholder="Email">
                    <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                </div>

                <div  class="form-group" v-if="form.payment">
                    <label>Amount <br>
                        <!--{{
                            form.payment === 'stripe' ? `[ This transaction qualifies for a promotional ${actual_discount}% discount]` : ''
                        }}-->
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        {{ !methods[form.payment] ? form.currency : methods[form.payment] }}
                    </span>
                        </div>
                        <input type="number" disabled :value="form.currency === 'USD'? totalPayment : discounted "
                               :class="[ 'form-control' , form.errors.get('amount') ? 'is-invalid' : '' ]"
                               placeholder="Amount">
                        <!-- <div v-if="form.payment === 'stripe'" class="input-group-prepend bg-success text-white">
                             <span class="input-group-text bg-success text-white">
                                 Discounted Price
                             </span>
                         </div>-->
                        <div v-text="form.errors.get('amount')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="form-group d-flex align-items-center">
                    <input type="checkbox" class="mr-2" id="checkterms" v-model="termsAccepted">
                    <label class="mb-0" for="checkterms">I accept the <a target="_blank" href="/terms">Terms & Conditions</a></label>
                </div>
            </div>
        </transition>

        <div class="form-group">
            <button @click="formVisibility ? submit($event) : (formVisibility = true)"
                    type="button"
                    v-bind="buttonValidity"
                    :class="{'btn-loading': form.loading, ...buttonValidity.class }">Buy Bundle
            </button>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import PhoneInput from "../../custom/phone-input.vue";
import {validity} from "../../../core/forms/validity";
import {appDataMixin} from "../../../core/data/global";

export default {
    name: "dashboard",
    mixins: [validity, appDataMixin],
    components: {PhoneInput},
    data: function () {
        return {
            meterLoading: false,
            fields: [
                'account',
                'phone',
                'amount',
                'email',
                'ecocash'
            ],
            methods: {
                'ecocash': 'ZWG',
                'ecocash-usd': 'USD',
                'stripe': 'USD',
            },
            meter: {},
            bundles: [],
            bundlesUSD: [],
            categories: [],
            rate: 1,
            paymentPremium:0,
            paymentPremiumAccepted: false,
            discount: 1,
            loading: true,
            form: new Form({
                'type': 'purchase',
                'account': '',
                'payment': 'ecocash-usd',
                'category': '',
                'bundle': '',
                'currency': '',
                'phone': '',
                'ecocash': '',
                'amount': '',
                'email': '',
            })
        };
    },

    computed: {
        totalPayment(){
            const amount = parseFloat(this.selected_bundle_price);
            if(this.form.payment === 'stripe'){

                const premium = 1 + (this.paymentPremium / 100);
                return amount * premium;

            }else{
                return amount;
            }

        },
        actual_discount() {
            return Math.floor((((this.discount) / (1 + this.discount)) * 100));
        },
        price: function () {
            return this.calculateUsdPrice(this.selected_bundle_price);
        },
        discounted: function () {
            return this.form.currency === 'ZWG' ? this.calculateDiscountedUsdPrice(this.selected_bundle_price) : this.selected_bundle_price ;
        },
        selected_bundle_price() {
            return this.form.bundle !== '' && !this.loading ? this.bundles.find(e => e.id === this.form.bundle).price : 0
        },
        filteredBundles() {
            return (this.form.category === '' && !this.loading ? this.bundles : this.bundles.filter(e => e.ProductDescription === this.form.category && (((this.form.currency === 'USD' && e.ProductCurrency === 'USD')) || (this.form.currency === 'ZWG' && e.ProductCurrency === 'ZWG') ))).map(
                e => ({
                    ...e,
                    ratedPrice: this.methods[this.form.payment] === "ZWG" ? e.price : this.calculateUsdPrice(e.price)
                })
            );
        },
    },

    methods: {

        calculateUsdPrice(price) {
            price = parseFloat(price);
            return this.methods[this.form.payment] === "ZWG"
                ? price :
                ((price / this.rate)).toFixed(2);
        },

        calculateDiscountedUsdPrice(price) {
            price = parseFloat(price);
            return this.methods[this.form.payment] === "ZWG"
                ? price :
                ((price / this.rate) *
                    ((1 - this.actual_discount / 100))
                ).toFixed(2);
        },

        fetchBundles() {
            this.loading = true;
            window.axios.get(`${window.location.origin}/telone/prepare`).then((response) => {
                this.bundles = response.data.body.bundles;
                this.categories = response.data.body.categories;
                if (this.form.currency === 'USD') {
                    this.paymentPremium = response.data.body.premium;
                }
                this.rate = response.data.body.rate;
                this.discount = response.data.body.discount / 100;
                this.getFromLocalStorage();
            }).finally(() => {
                this.loading = false;
            });
        },

        saveToLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                localStorage.setItem(`telone-${this.fields[i]}`, this.form[this.fields[i]]);
            }
        },
        getFromLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {

                let value = localStorage.getItem(`telone-${this.fields[i]}`);
                if (value != null && value !== "" && value !== "null") {
                    this.form[this.fields[i]] = value;
                }
            }
        },

        submit(event) {
            // Save to Local Storage

            if (this.$refs.form.checkValidity() && !this.form.errors.any()) {
                event.preventDefault()

                this.saveToLocalStorage();
                this.form.submit('/telone/init').then((response) => {
                    if (response.data.success) {
                        if (response.data.body.payment.payment === "ecocash" || response.data.body.payment.payment === "ecocash-usd") {
                            this.$router.push(`/telone/ecocash?id=${response.data.body.payment.ref}`);
                        }

                        if (response.data.body.payment.payment === "stripe") {
                            window.location.href = response.data.body.payment.url;
                        }

                    } else {

                    }
                });
            }
        }
    },

    mounted() {
        this.fetchBundles();
        this.form.currency = this.currency;

        // Check in Local Storage

        this.getFromLocalStorage();

        // Check Meter Number

        if (this.form.account !== "") {
            this.checkMeterNumber();
        }

        this.scrollToTop();
    }
}
</script>

<style scoped>

</style>
